<template>
  <base-entity-card
    :id="id"
    titleName="сотрудника"
    :saveFunc="save"
    :loading="loading"
    @closed="restoreEntity"
    :oneColumn="true"
  >
    <v-form ref="form" v-model="isValid">
      <v-autocomplete
        label="Сайт"
        v-model="entity.site"
        :items="sitesSelectData"
        clearable
        filled
      ></v-autocomplete>
      <v-text-field
        label="Фамилия"
        v-model="entity.lastName"
        filled
      ></v-text-field>
      <v-text-field
        label="Имя *"
        v-model="entity.firstName"
        :rules="[v => !!v || 'Введите имя.']"
        filled
      ></v-text-field>
      <v-text-field
        label="Отчество"
        v-model="entity.middleName"
        filled
      ></v-text-field>
      <v-autocomplete
        label="Должность *"
        v-model="entity.position"
        :rules="[v => !!v || 'Введите должность.']"
        filled
        :items="positionNames"
      ></v-autocomplete>
      <v-textarea
        label="Описание сотрудника"
        v-model="entity.about"
        filled
      ></v-textarea>
      <v-text-field
        label="Опыт (лет) *"
        v-model="entity.yearsOfExperience"
        filled
        :rules="[v => !!v || 'Введите опыт.', v => !v || isNumber(v) || 'Введите число']"
      ></v-text-field>
      <v-text-field
        label="Сдано (объектов) *"
        v-model="entity.objectsCount"
        filled
        :rules="[v => !!v || 'Введите число объектов.', v => !v || isNumber(v) || 'Введите число']"
      ></v-text-field>
      <files-table
        :smIndex="12"
        label="Простое фото"
        :singleFile="true"
        v-model="entity.simplePhoto"
        :key="'f1' + filesId"
      ></files-table>
      <files-table
        :smIndex="12"
        label="Фан фото"
        :singleFile="true"
        v-model="entity.funPhoto"
        :key="'f2' + filesId"
      ></files-table>
      <files-table
        :smIndex="12"
        label="Аватар"
        :singleFile="true"
        v-model="entity.avatarPhoto"
        :key="'f3' + filesId"
      ></files-table>
    </v-form>
  </base-entity-card>
</template>

<script>
import { getTempId } from '../../../models/common';
import SiteEntityMixin from '../../../models/SiteEntityMixin';

export default {
  name: 'site-specialist-card',

  mixins: [SiteEntityMixin],

  data() {
    return {
      tag: 'specialist',
      filesId: getTempId(),
      positionNames: Object.keys(
        {
          'Главный инженер': '',
          'Руководитель': '',
          'Инженер': 'Инженеры',
          'Дизайнер': 'Дизайнеры',
          'Электрик': 'Электрики',
          'Сантехник': 'Сантехники',
          'Специалист по ГКЛ': 'Специалисты по ГКЛ',
          'Плиточник': 'Плиточники',
          'Маляр': 'Малярная команда',
          'Отделочник-универсал': 'Отделочники-универсалы',
          'Разнорабочий': 'Разнорабочие',
          'Потолочник': 'Натяжные потолки',
          'Кондиционерщик': 'Кондиционерщики',
        }
      )
    }
  },

  methods: {
    getDefaultEntity() {
      this.filesId = getTempId();
      return {
        site: null,
        firstName: '',
        middleName: '',
        lastName: '',
        position: '',
        about: '',
        yearsOfExperience: 1,
        objectsCount: '',
        simplePhoto: [],
        funPhoto: [],
        avatarPhoto: []
      }
    },
  },
}
</script>